import {
  combineReducers,
  createStore,
  compose,
  applyMiddleware,
  Middleware,
  Store,
} from 'redux';
import { routeReducer, syncHistory } from 'react-router-redux';
import { browserHistory } from 'react-router';
import thunk from 'redux-thunk';
import { forms, FormState } from '../reducers';
import { createLogger } from 'redux-logger';

export type RootState = {
  routing: any;
  forms: FormState;
};

const logger = createLogger();
const reduxRouterMiddleware = syncHistory(browserHistory);
const rootReducer = combineReducers<RootState>({
  routing: routeReducer,
  forms: forms,
});

let store: Store<RootState>;

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV === 'production') {
  store = createStore(
    rootReducer,
    compose(applyMiddleware(thunk, reduxRouterMiddleware)),
  );
} else {
  store = createStore(
    rootReducer,
    compose(applyMiddleware(thunk, reduxRouterMiddleware)), //, logger
  );

  // @ts-ignore
  // window._store = store;
}

export { store };
